import { Id } from "./id";
import { Snakify } from "./snakify";

export type CustomTypes = CustomType[];

export enum NewValuesSetting {
  Allowed = "allowed",
  NotAllowed = "not_allowed",
  RequireApproval = "require_approval",
  RequireApprovalLocal = "require_approval_local",
  GlobalOnly = "global_only"
}

export type _CustomType = {
  id: Id;
  name: "skills" | string;
  kind?: "multiple" | "single";
  displayAs?: string;
  title?: string;
  orderable?: boolean;
  valueType: "string" | "integer" | "date" | "location" | "boolean";
  newValues: NewValuesSetting;
  sections: Section[];
  position: number;
  description: string;
  suggestionDescription?: string;
  attributesTranslatable: boolean;
  customValuesTranslatable: boolean;
  permitted: boolean;
};

export type CustomType = Snakify<_CustomType>;

type Section = {
  id: number;
  key: string;
};
